import PropTypes from 'prop-types';

function IFMeatAndSeafoodActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11289)">
                <path
                    d="M27.3599 7.05007C27.4086 6.3277 27.5399 3.48674 25.4763 2.18181C23.4126 0.876888 17.1963 0.451999 13.2192 2.95341C9.24213 5.45483 9.6294 10.2763 12.2424 12.9874C14.2517 15.0928 16.5939 16.8532 19.1749 18.198C22.1577 19.7983 25.3491 20.8024 26.9478 20.3077C28.5466 19.813 30.7039 18.4789 29.6427 15.4097C29.1786 14.3488 28.0678 13.6252 27.4886 12.4474C26.9093 11.2696 27.2199 9.01584 27.3599 7.05007Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25.6115 8.71008C25.6605 8.12523 26.3114 4.85534 24.5153 3.66104C22.7193 2.46675 17.3502 2.43804 14.2531 4.20291C11.1559 5.96779 11.5119 9.92127 13.8531 12.3022C16.1942 14.6832 18.116 15.7414 19.843 16.757C22.4186 18.2591 24.4243 18.9199 25.8692 18.8012C27.1662 18.6921 28.8885 17.7472 28.0413 15.6138C27.666 14.6777 26.6368 14.0563 26.0755 13.0567C25.5142 12.0571 25.4597 10.5125 25.6115 8.71008Z"
                    fill="#D9291F"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M22.0253 5.68413C23.3918 5.43134 23.6661 6.838 22.682 7.12584C20.8648 7.66001 20.0767 7.72691 19.6183 7.92688C19.0378 8.17989 18.6474 9.17573 22.0744 12.7319C23.5405 14.253 24.9346 15.5487 24.2371 16.1606C23.7038 16.6308 22.1245 15.1418 20.2581 13.1088C17.2519 9.82575 18.1354 8.95112 17.172 8.83901C16.2085 8.7269 14.3063 9.62318 13.9763 8.48398C13.7947 7.82639 14.2421 7.60443 16.7228 6.87597C18.4664 6.37906 20.2367 5.98114 22.0253 5.68413V5.68413Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.3736 13.4984C3.01826 13.0364 7.96495 10.6204 12.1735 12.8296C16.3821 15.0389 18.0661 17.6455 19.2705 21.5908C21.5243 20.8253 23.6374 20.8032 25.8441 23.4272C24.4466 22.9838 22.1567 24.2306 21.3665 25.4432C20.4178 26.8764 20.6809 28.4966 21.5906 30.2815C19.3301 29.8167 16.6553 28.4308 17.2265 25.047C15.365 25.9506 13.2727 26.2663 11.2276 25.9523C9.18243 25.6383 7.28121 24.7095 5.77652 23.2892C1.35248 19.1834 2.3736 13.4984 2.3736 13.4984Z"
                    fill="#F7D46D"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.401 11.9843C10.3292 11.705 11.2708 11.4728 12.2224 11.2883C13.777 10.9824 15.9283 12.257 17.2352 13.4848C18.5421 14.7126 19.3961 15.6923 19.4684 16.151C19.5406 16.6097 18.4884 19.1077 18.4884 19.1077C18.4884 19.1077 16.6286 15.3451 13.958 13.8892C12.5203 13.075 10.9905 12.4355 9.401 11.9843V11.9843Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.03265 21.2002C4.46589 21.1445 7.03824 21.1129 9.43819 18.473C11.8381 15.8332 10.8766 12.4642 10.8766 12.4642C10.8766 12.4642 7.05948 10.8993 2.37359 13.4982C1.69933 17.5709 4.03265 21.2002 4.03265 21.2002Z"
                    fill="white"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.22876 15.363C7.57235 15.4027 7.88306 15.1564 7.92277 14.8128C7.96247 14.4692 7.71613 14.1585 7.37254 14.1188C7.02896 14.0791 6.71824 14.3254 6.67853 14.669C6.63883 15.0126 6.88517 15.3233 7.22876 15.363Z"
                    fill="#F7D46D"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.7643 16.1478C10.7643 16.1478 12.8107 17.0421 13.1384 20.3731C10.0369 21.765 7.9449 19.8081 7.9449 19.8081C7.9449 19.8081 9.35493 19.466 10.7643 16.1478Z"
                    fill="#F4F0F2"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.533 18.4215C16.1722 18.9888 15.4232 20.3197 14.7242 20.1684C15.2505 20.8323 14.5563 22.1969 13.6057 22.0871C13.7085 22.2599 13.7609 22.4581 13.757 22.6591C13.753 22.8602 13.6929 23.0561 13.5833 23.2248C13.4738 23.3934 13.3193 23.5281 13.1372 23.6134C12.9551 23.6988 12.7528 23.7316 12.5531 23.7079"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.7244 20.4468C17.3309 20.9593 16.6147 22.345 15.7449 22.1465C16.1484 22.8902 15.5858 23.9294 14.6922 23.7674"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11289">
                    <rect width="30" height="30" fill="white" transform="translate(0.545898 0.303711)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFMeatAndSeafoodActive;

IFMeatAndSeafoodActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFMeatAndSeafoodActive.defaultProps = {
    className: null,
};
